/* eslint-disable no-multi-str */
import React from 'react'
import { ImagePickerSidebar, GalleryItem } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const FormGallery = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div>
      <div className="mb-5">
        <p className="text-lg font-bold mb-5">Gallery</p>
        <ImagePickerSidebar height={isMobile ? '160px' : '110px'} buttonWidth="160px" message="JPG, GIF or PNG no larger than 1MB."/>
      </div>
      <div className="flex flex-wrap -mx-1 lg:-mx-2 mb-8">
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_1.jpg"/>
        </div>
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_2.jpg"/>
        </div>
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_3.jpg"/>
        </div>
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_4.jpg"/>
        </div>
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_3.jpg"/>
        </div>
        <div className="w-1/3 lg:w-1/4 px-1 lg:px-2 mb-2 lg:mb-4">
          <GalleryItem height={isMobile ? '66px' : '81px'} src="/images/articles/khub_artikel_4.jpg"/>
        </div>
      </div>
    </div>
  )
}

export { FormGallery }